export default [
    {
        path: '/fwshop',
        meta: {
        },
        component: () => import('@/views/1531/fwshop')
    }
]
